// extracted by mini-css-extract-plugin
export default {"directors":"styles_directors__JVJVj"};